import { jsx as c, Fragment as U } from "react/jsx-runtime";
import * as s from "react";
import E from "react";
import { c as L, a as j, d as Te, b as T } from "../index-Dn5fq5RO.js";
import { c as H, u as D } from "../index-BwdHfdWj.js";
import { u as Y } from "../index-_igB3qdS.js";
import "../index-DWGznc13.js";
import { u as q } from "../index-D-9pS3Rt.js";
import { P as he } from "../index-C7ixzbBF.js";
import { c as F } from "../index-Cu0xwYjD.js";
var _ = s.forwardRef((e, t) => {
  const { children: r, ...o } = e, n = s.Children.toArray(r), i = n.find(we);
  if (i) {
    const a = i.props.children, l = n.map((f) => f === i ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : f);
    return /* @__PURE__ */ c(V, { ...o, ref: t, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ c(V, { ...o, ref: t, children: r });
});
_.displayName = "Slot";
var V = s.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const n = Ne(r), i = Se(o, r.props);
    return r.type !== s.Fragment && (i.ref = t ? H(t, n) : n), s.cloneElement(r, i);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
V.displayName = "SlotClone";
var Ee = ({ children: e }) => /* @__PURE__ */ c(U, { children: e });
function we(e) {
  return s.isValidElement(e) && e.type === Ee;
}
function Se(e, t) {
  const r = { ...t };
  for (const o in t) {
    const n = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? n && i ? r[o] = (...l) => {
      i(...l), n(...l);
    } : n && (r[o] = n) : o === "style" ? r[o] = { ...n, ...i } : o === "className" && (r[o] = [n, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Ne(e) {
  var o, n;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function _e(e) {
  const t = e + "CollectionProvider", [r, o] = L(t), [n, i] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (y) => {
    const { scope: u, children: b } = y, I = E.useRef(null), m = E.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(n, { scope: u, itemMap: m, collectionRef: I, children: b });
  };
  a.displayName = t;
  const l = e + "CollectionSlot", f = E.forwardRef(
    (y, u) => {
      const { scope: b, children: I } = y, m = i(l, b), g = D(u, m.collectionRef);
      return /* @__PURE__ */ c(_, { ref: g, children: I });
    }
  );
  f.displayName = l;
  const d = e + "CollectionItemSlot", v = "data-radix-collection-item", p = E.forwardRef(
    (y, u) => {
      const { scope: b, children: I, ...m } = y, g = E.useRef(null), w = D(u, g), S = i(d, b);
      return E.useEffect(() => (S.itemMap.set(g, { ref: g, ...m }), () => void S.itemMap.delete(g))), /* @__PURE__ */ c(_, { [v]: "", ref: w, children: I });
    }
  );
  p.displayName = d;
  function C(y) {
    const u = i(e + "CollectionConsumer", y);
    return E.useCallback(() => {
      const I = u.collectionRef.current;
      if (!I) return [];
      const m = Array.from(I.querySelectorAll(`[${v}]`));
      return Array.from(u.itemMap.values()).sort(
        (S, N) => m.indexOf(S.ref.current) - m.indexOf(N.ref.current)
      );
    }, [u.collectionRef, u.itemMap]);
  }
  return [
    { Provider: a, Slot: f, ItemSlot: p },
    C,
    o
  ];
}
var Fe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], z = Fe.reduce((e, t) => {
  const r = s.forwardRef((o, n) => {
    const { asChild: i, ...a } = o, l = i ? _ : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...a, ref: n });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), x = "rovingFocusGroup.onEntryFocus", Ae = { bubbles: !1, cancelable: !0 }, A = "RovingFocusGroup", [$, Z, Pe] = _e(A), [Me, J] = L(
  A,
  [Pe]
), [Oe, xe] = Me(A), Q = s.forwardRef(
  (e, t) => /* @__PURE__ */ c($.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c($.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(De, { ...e, ref: t }) }) })
);
Q.displayName = A;
var De = s.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: o,
    loop: n = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: f,
    onEntryFocus: d,
    preventScrollOnEntryFocus: v = !1,
    ...p
  } = e, C = s.useRef(null), y = D(t, C), u = q(i), [b = null, I] = j({
    prop: a,
    defaultProp: l,
    onChange: f
  }), [m, g] = s.useState(!1), w = Te(d), S = Z(r), N = s.useRef(!1), [be, W] = s.useState(0);
  return s.useEffect(() => {
    const R = C.current;
    if (R)
      return R.addEventListener(x, w), () => R.removeEventListener(x, w);
  }, [w]), /* @__PURE__ */ c(
    Oe,
    {
      scope: r,
      orientation: o,
      dir: u,
      loop: n,
      currentTabStopId: b,
      onItemFocus: s.useCallback(
        (R) => I(R),
        [I]
      ),
      onItemShiftTab: s.useCallback(() => g(!0), []),
      onFocusableItemAdd: s.useCallback(
        () => W((R) => R + 1),
        []
      ),
      onFocusableItemRemove: s.useCallback(
        () => W((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ c(
        z.div,
        {
          tabIndex: m || be === 0 ? -1 : 0,
          "data-orientation": o,
          ...p,
          ref: y,
          style: { outline: "none", ...e.style },
          onMouseDown: T(e.onMouseDown, () => {
            N.current = !0;
          }),
          onFocus: T(e.onFocus, (R) => {
            const Ce = !N.current;
            if (R.target === R.currentTarget && Ce && !m) {
              const B = new CustomEvent(x, Ae);
              if (R.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
                const O = S().filter((h) => h.focusable), Re = O.find((h) => h.active), ye = O.find((h) => h.id === b), Ie = [Re, ye, ...O].filter(
                  Boolean
                ).map((h) => h.ref.current);
                te(Ie, v);
              }
            }
            N.current = !1;
          }),
          onBlur: T(e.onBlur, () => g(!1))
        }
      )
    }
  );
}), X = "RovingFocusGroupItem", ee = s.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: o = !0,
      active: n = !1,
      tabStopId: i,
      ...a
    } = e, l = Y(), f = i || l, d = xe(X, r), v = d.currentTabStopId === f, p = Z(r), { onFocusableItemAdd: C, onFocusableItemRemove: y } = d;
    return s.useEffect(() => {
      if (o)
        return C(), () => y();
    }, [o, C, y]), /* @__PURE__ */ c(
      $.ItemSlot,
      {
        scope: r,
        id: f,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ c(
          z.span,
          {
            tabIndex: v ? 0 : -1,
            "data-orientation": d.orientation,
            ...a,
            ref: t,
            onMouseDown: T(e.onMouseDown, (u) => {
              o ? d.onItemFocus(f) : u.preventDefault();
            }),
            onFocus: T(e.onFocus, () => d.onItemFocus(f)),
            onKeyDown: T(e.onKeyDown, (u) => {
              if (u.key === "Tab" && u.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (u.target !== u.currentTarget) return;
              const b = Ge(u, d.orientation, d.dir);
              if (b !== void 0) {
                if (u.metaKey || u.ctrlKey || u.altKey || u.shiftKey) return;
                u.preventDefault();
                let m = p().filter((g) => g.focusable).map((g) => g.ref.current);
                if (b === "last") m.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && m.reverse();
                  const g = m.indexOf(u.currentTarget);
                  m = d.loop ? Le(m, g + 1) : m.slice(g + 1);
                }
                setTimeout(() => te(m));
              }
            })
          }
        )
      }
    );
  }
);
ee.displayName = X;
var Ve = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $e(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ge(e, t, r) {
  const o = $e(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Ve[o];
}
function te(e, t = !1) {
  const r = document.activeElement;
  for (const o of e)
    if (o === r || (o.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function Le(e, t) {
  return e.map((r, o) => e[(t + o) % e.length]);
}
var Ke = Q, ke = ee, oe = s.forwardRef((e, t) => {
  const { children: r, ...o } = e, n = s.Children.toArray(r), i = n.find(Be);
  if (i) {
    const a = i.props.children, l = n.map((f) => f === i ? s.Children.count(a) > 1 ? s.Children.only(null) : s.isValidElement(a) ? a.props.children : null : f);
    return /* @__PURE__ */ c(G, { ...o, ref: t, children: s.isValidElement(a) ? s.cloneElement(a, void 0, l) : null });
  }
  return /* @__PURE__ */ c(G, { ...o, ref: t, children: r });
});
oe.displayName = "Slot";
var G = s.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const n = je(r), i = Ue(o, r.props);
    return r.type !== s.Fragment && (i.ref = t ? H(t, n) : n), s.cloneElement(r, i);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
G.displayName = "SlotClone";
var We = ({ children: e }) => /* @__PURE__ */ c(U, { children: e });
function Be(e) {
  return s.isValidElement(e) && e.type === We;
}
function Ue(e, t) {
  const r = { ...t };
  for (const o in t) {
    const n = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? n && i ? r[o] = (...l) => {
      i(...l), n(...l);
    } : n && (r[o] = n) : o === "style" ? r[o] = { ...n, ...i } : o === "className" && (r[o] = [n, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function je(e) {
  var o, n;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var He = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], P = He.reduce((e, t) => {
  const r = s.forwardRef((o, n) => {
    const { asChild: i, ...a } = o, l = i ? oe : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(l, { ...a, ref: n });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), K = "Tabs", [Ye, pt] = L(K, [
  J
]), re = J(), [qe, k] = Ye(K), ne = s.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: o,
      onValueChange: n,
      defaultValue: i,
      orientation: a = "horizontal",
      dir: l,
      activationMode: f = "automatic",
      ...d
    } = e, v = q(l), [p, C] = j({
      prop: o,
      onChange: n,
      defaultProp: i
    });
    return /* @__PURE__ */ c(
      qe,
      {
        scope: r,
        baseId: Y(),
        value: p,
        onValueChange: C,
        orientation: a,
        dir: v,
        activationMode: f,
        children: /* @__PURE__ */ c(
          P.div,
          {
            dir: v,
            "data-orientation": a,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
ne.displayName = K;
var se = "TabsList", ie = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: o = !0, ...n } = e, i = k(se, r), a = re(r);
    return /* @__PURE__ */ c(
      Ke,
      {
        asChild: !0,
        ...a,
        orientation: i.orientation,
        dir: i.dir,
        loop: o,
        children: /* @__PURE__ */ c(
          P.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...n,
            ref: t
          }
        )
      }
    );
  }
);
ie.displayName = se;
var ae = "TabsTrigger", ce = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: o, disabled: n = !1, ...i } = e, a = k(ae, r), l = re(r), f = fe(a.baseId, o), d = de(a.baseId, o), v = o === a.value;
    return /* @__PURE__ */ c(
      ke,
      {
        asChild: !0,
        ...l,
        focusable: !n,
        active: v,
        children: /* @__PURE__ */ c(
          P.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": v,
            "aria-controls": d,
            "data-state": v ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: f,
            ...i,
            ref: t,
            onMouseDown: T(e.onMouseDown, (p) => {
              !n && p.button === 0 && p.ctrlKey === !1 ? a.onValueChange(o) : p.preventDefault();
            }),
            onKeyDown: T(e.onKeyDown, (p) => {
              [" ", "Enter"].includes(p.key) && a.onValueChange(o);
            }),
            onFocus: T(e.onFocus, () => {
              const p = a.activationMode !== "manual";
              !v && !n && p && a.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
ce.displayName = ae;
var le = "TabsContent", ue = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: o, forceMount: n, children: i, ...a } = e, l = k(le, r), f = fe(l.baseId, o), d = de(l.baseId, o), v = o === l.value, p = s.useRef(v);
    return s.useEffect(() => {
      const C = requestAnimationFrame(() => p.current = !1);
      return () => cancelAnimationFrame(C);
    }, []), /* @__PURE__ */ c(he, { present: n || v, children: ({ present: C }) => /* @__PURE__ */ c(
      P.div,
      {
        "data-state": v ? "active" : "inactive",
        "data-orientation": l.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !C,
        id: d,
        tabIndex: 0,
        ...a,
        ref: t,
        style: {
          ...e.style,
          animationDuration: p.current ? "0s" : void 0
        },
        children: C && i
      }
    ) });
  }
);
ue.displayName = le;
function fe(e, t) {
  return `${e}-trigger-${t}`;
}
function de(e, t) {
  return `${e}-content-${t}`;
}
var ze = ne, Ze = ie, Je = ce, Qe = ue;
const Xe = "_root_1byi4_1", et = "_list_1byi4_7", tt = "_trigger_1byi4_12", ot = "_content_1byi4_41", M = {
  root: Xe,
  list: et,
  trigger: tt,
  content: ot
}, pe = s.forwardRef(({ className: e, initialId: t, id: r, ...o }, n) => /* @__PURE__ */ c(
  ze,
  {
    ref: n,
    className: F(M.root, e),
    defaultValue: t,
    value: r,
    ...o
  }
));
pe.displayName = "Tabs.Root";
const me = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ c(
  Ze,
  {
    ref: r,
    className: F(M.list, e),
    ...t
  }
));
me.displayName = "Tabs.List";
const ve = s.forwardRef(({ className: e, id: t, ...r }, o) => /* @__PURE__ */ c(
  Je,
  {
    ref: o,
    className: F(M.trigger, e),
    value: t,
    ...r
  }
));
ve.displayName = "Tabs.Trigger";
const ge = s.forwardRef(({ className: e, id: t, ...r }, o) => /* @__PURE__ */ c(
  Qe,
  {
    ref: o,
    className: F(M.content, e),
    value: t,
    ...r
  }
));
ge.displayName = "Tabs.Content";
const mt = {
  Root: pe,
  List: me,
  Trigger: ve,
  Content: ge
};
export {
  mt as Tabs
};
